module.exports = __webpack_public_path__ + "static/client3-88015db2ac0f8fea07a4985dda1e0a34.png";